import React, { useState, useEffect } from "react";
import { VsiH4, VsiHr } from "../../styled/App.styled";
import { useVsiAppContext } from "../../stores/VsiApp";
import { Spinner } from "reactstrap";
import { GetAuth, PutAuth, DeleteAuth } from "../../utils/Verbs";
import Grid from "../../components/Grid";
import Toggle from "react-toggle";
import { Button } from "reactstrap";

const serviceStyle = {
  height: 36,
  textAlign: "center"
};

const approvalToggleRenderer = e => {
  /*
  I used this tutorial for reference:
  https://thinkster.io/tutorials/using-ag-grid-with-react-data/more-on-framework-component-cell-renderers
   */
  return (
    <div style={serviceStyle}>
      <Toggle style={{
        margin: 10,
        textAlign: "center"
      }} checked={e.value} onChange={e.onToggle} data-_id={e.data._id} />
    </div>
  );
};

const deregisterButtonHandler = e => {
  return (
    <div style={serviceStyle}>
      <Button color={"danger"}
              onClick={e.onDeregisterClick}
              data-_id={e.data._id}>
        <i className={"fa-solid fa-trash"} />
      </Button>
    </div>
  );
};

export default function({ title }) {
  const { user, getAccessTokenSilently } = useVsiAppContext();
  const [isLoading, setIsLoading] = useState(true);
  const [allServices, setAllServices] = useState([]);
  // updateTrigger is used to force the grid to refresh after you click one of the toggles.
  // The value of updateTrigger is irrelevant.  It is the changing of the value that causes
  // the useEffect hook to run to update the grid data.  Once again, NOTHING depends on the value
  // of updateTrigger.  Its change forces the grid to refresh.
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const getToken = async () => await getAccessTokenSilently();
  const serviceColumnDefinitions = [
    {
      field: "_id",
      headerName: "Service ID"
    },
    {
      field: "serviceType",
      headerName: "Service Type"
    },
    { field: "ipAddress", headerName: "IP Address" },
    {
      field: "instanceName",
      headerName: "Instance Name"
    },
    {
      field: "approved",
      headerName: "Approved",
      cellRenderer: approvalToggleRenderer,
      cellRendererParams: {
        token: getToken(),
        onToggle: async e => {
          const { target } = e;
          const data = { _id: target.dataset._id, approved: target.checked };
          const token = await getAccessTokenSilently();
          PutAuth("/api/v6/admin/service-approval", data, token)
            .then(() => {
              setUpdateTrigger(!updateTrigger);
            });
        }
      }
    },
    {
      field: "lastAccess",
      headerName: "Last Access"
    },
    {
      headerName: "Delete",
      cellRenderer: deregisterButtonHandler,
      cellRendererParams: {
        token: getToken(),
        onDeregisterClick: e => {
          const { target } = e;
          DeleteAuth(`/api/v6/admin/deregister-service/${target.dataset._id}`, getToken())
            .then(() => {
              setUpdateTrigger(!updateTrigger);
            });
        }
      }
    }
  ];


  useEffect(() => {
    const getServices = async () => {
      const token = await getAccessTokenSilently();
      GetAuth("/api/v6/admin/registered-services", token)
        .then(data => {
          setAllServices(data.data);
          setIsLoading(false);
        })
        .catch(err => {
          console.error(err);
          setIsLoading(false);
        });
    };

    getServices();
  }, [updateTrigger]);

  return (
    <div>
      <VsiH4>{title}</VsiH4>
      <VsiHr />
      {isLoading ? <Spinner color={"primary"} /> :
        <Grid data={allServices}
              columnDefs={serviceColumnDefinitions}
        />
      }
    </div>
  );
}
